const riskStatusOptions = [
  {
    value: "pass",
    label: "Pass",
  },
  {
    value: "refer",
    label: "Refer",
  },
  {
    value: "fail",
    label: "Fail",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

// Application summary decision. Stored values are unchanged (pass / fail /
// pending); only the labels read Approve / Decline.
const passFailOptions = [
  {
    value: "pass",
    label: "Approve",
  },
  {
    value: "fail",
    label: "Decline",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

// A reason option may ask for free text via `detail`; `required` makes the
// text mandatory before the choice can be confirmed.
const otherReason = {
  value: "other",
  label: "Other",
  detail: { label: "Reason", required: true },
};

// Why an application was declined. Recorded for staff; the decline letter
// is generated for every decline regardless of reason.
const declineReasonOptions = [
  {
    value: "failedAffordability",
    label: "Failed affordability",
  },
  {
    value: "adverseCraData",
    label: "Adverse CRA data",
  },
  {
    value: "adverseSmartSearchData",
    label: "Adverse SmartSearch data",
  },
  otherReason,
];

// Why an application was closed without proceeding.
const closeReasonOptions = [
  {
    value: "didNotBuy",
    label: "Did not buy",
  },
  {
    value: "paidCash",
    label: "Paid cash",
  },
  {
    value: "noResponse",
    label: "No response",
  },
  {
    value: "fundedElsewhere",
    label: "Funded elsewhere",
    detail: { label: "Lender and interest rate (if known)", required: false },
  },
  {
    value: "boatUnsuitable",
    label: "Boat unsuitable",
  },
  {
    value: "liveaboard",
    label: "Liveaboard",
  },
  otherReason,
];

const getReasonLabel = (options) => (value) =>
  options.find((option) => option.value === value)?.label ?? value;

const getDeclineReasonLabel = getReasonLabel(declineReasonOptions);
const getCloseReasonLabel = getReasonLabel(closeReasonOptions);

const applicationConfig = {
  riskStatusOptions,
  passFailOptions,
  declineReasonOptions,
  getDeclineReasonLabel,
  closeReasonOptions,
  getCloseReasonLabel,
};
export default applicationConfig;
